import React, { useEffect, useState, useRef, useContext } from "react";
// import React, { useEffect, useState, useRef } from "react";
// import { CheckCircle, XCircle, Loader2, AlertCircle, ArrowLeft } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Cookies from "js-cookie";
// import { jwtDecode } from "jwt-decode";
// import apiConfig from "../config/apiConfig";

// type PaymentStatusType =
//   | "CREATED"
//   | "SUCCESS"
//   | "FAILED"
//   | "INVALID";

// const PaymentStatus: React.FC = () => {
//   const navigate = useNavigate();
//   const [status, setStatus] = useState<PaymentStatusType>("CREATED");
//   const hasUpdatedStatus = useRef(false);

//   const base64Encode = (str: string) => {
//     return btoa(unescape(encodeURIComponent(str)));
//   };

//   // Update application_track status from DRAFT -> SUBMITTED
//   const updateApplicationStatus = async () => {
//     if (hasUpdatedStatus.current) return; // prevent duplicate calls
//     hasUpdatedStatus.current = true;

//     try {
//       const token = Cookies.get("access_token");
//       if (!token) return;

//       const decoded: any = jwtDecode(token);
//       const userId = decoded.custom_id || "";
//       if (!userId) return;

//       // Fetch user's application tracks
//       const appRes = await fetch(
//         `${apiConfig.getResourceUrl('application_track')}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${userId}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             "Authorization": `Bearer ${token}`,
//           },
//         }
//       );

//       if (!appRes.ok) return;
//       const appData = await appRes.json();
//       const applications = appData.resource || [];

//       // Find DRAFT applications and update to SUBMITTED with payment_status
//       for (const app of applications) {
//         if (app.status === "DRAFT") {
//           const updatedApp = {
//             ...app,
//             status: "SUBMITTED",
//             extra_data: {
//               ...(app.extra_data || {}),
//               payment_status: "SUCCESS"
//             }
//           };
//           const formData = new FormData();
//           const jsonString = JSON.stringify(updatedApp);
//           const base64Encoded = base64Encode(jsonString);
//           formData.append('resource', base64Encoded);
//           formData.append('queryId', 'CREATE');

//           await fetch(
//             `${apiConfig.getResourceUrl('application_track')}`,
//             {
//               method: "POST",
//               headers: {
//                 "Authorization": `Bearer ${token}`,
//               },
//               body: formData,
//               credentials: "include"
//             }
//           );
//           console.log("PaymentStatus: Updated application", app.application_number, "to SUBMITTED with payment_status SUCCESS");
//         }
//       }
//     } catch (err) {
//       console.error("PaymentStatus: Error updating application status:", err);
//     }
//   };

//   useEffect(() => {

//     const params = new URLSearchParams(window.location.search);
//     const orderId = params.get("orderId");
//     console.log("OrderId:", orderId);
//     if (!orderId) {
//       setStatus("INVALID");
//       return;
//     }

//     const interval = setInterval(async () => {

//       const res = await fetch(
//         `http://localhost:8082/api/payments/status/${orderId}`
//       );
//       console.log("res:", res);
//       if (!res.ok) {
//         setStatus("INVALID");
//         clearInterval(interval);
//         return;
//       }

//       const data = await res.json();
//       setStatus(data.status);

//       if (data.status === "SUCCESS") {
//         clearInterval(interval);
//         // Update application status to SUBMITTED
//         await updateApplicationStatus();
//       } else if (data.status === "FAILED") {
//         clearInterval(interval);
//       }

//     }, 3000); // poll every 3 sec

//     return () => clearInterval(interval);

//   }, []);

//   return (
//     <div
//       style={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         backgroundColor: "#f4f7f6",
//         padding: "20px",
//       }}
//     >
//       <div
//         className="bg-white p-5 rounded shadow-lg text-center"
//         style={{ width: "450px", maxWidth: "100%" }}
//       >
//         {/* Status Area */}
//         <div className="mb-4">
//           {status === "CREATED" && (
//             <>
//               <Loader2 size={60} className="text-primary mb-3 mx-auto" style={{ animation: "spin 2s linear infinite" }} />
//               <h3 className="text-dark fw-bold">Processing Payment</h3>
//               <p className="text-muted mt-2">Please wait while we confirm your payment. Do not close or refresh this page.</p>
//             </>
//           )}

//           {status === "SUCCESS" && (
//             <>
//               <CheckCircle size={64} className="text-success mb-3 mx-auto" />
//               <h3 className="text-success fw-bold">Payment Successful!</h3>
//               <p className="text-muted mt-2">Your application fee has been received successfully.</p>
//             </>
//           )}

//           {status === "FAILED" && (
//             <>
//               <XCircle size={64} className="text-danger mb-3 mx-auto" />
//               <h3 className="text-danger fw-bold">Payment Failed</h3>
//               <p className="text-muted mt-2">Unfortunately, your payment could not be processed. Please try again.</p>
//             </>
//           )}

//           {status === "INVALID" && (
//             <>
//               <AlertCircle size={64} className="text-warning mb-3 mx-auto" />
//               <h3 className="text-dark fw-bold">Invalid Order</h3>
//               <p className="text-muted mt-2">We could not find the details for this payment order.</p>
//             </>
//           )}
//         </div>

//         {/* Action Button */}
//         <div className="mt-4 pt-4 border-top">
//           {status === "SUCCESS" ? (
//             <button
//               className="btn btn-success px-4 py-2 w-100"
//               style={{ fontSize: "16px", fontWeight: "500" }}
//               onClick={() => navigate("/applicant/home")} // Assuming there is a dashboard
//             >
//               Go to Home
//             </button>
//           ) : status === "FAILED" || status === "INVALID" ? (
//             <button
//               className="btn btn-primary px-4 py-2 w-100"
//               style={{ fontSize: "16px", fontWeight: "500" }}
//               onClick={() => navigate("/paymentinitiate")} // Adjust route if needed
//             >
//               <ArrowLeft size={18} className="me-2" />
//               Try Again
//             </button>
//           ) : null}
//         </div>

//         <style>{`
//           @keyframes spin {
//             0% { transform: rotate(0deg); }
//             100% { transform: rotate(360deg); }
//           }
//         `}</style>
//       </div>
//     </div>
//   );
// };

// export default PaymentStatus;import { CheckCircle, XCircle, Loader2, AlertCircle, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiConfig from "../config/apiConfig";
import { apiFetch } from "../apis/apiFetch";
import { LoginContext } from "../context/LoginContext";
import { AlertCircle, ArrowLeft, CheckCircle, Loader2, XCircle } from "lucide-react";

type PaymentStatusType =
  | "CREATED"
  | "SUCCESS"
  | "FAILED"
  | "INVALID";

const PaymentStatus: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useContext(LoginContext);
  const [status, setStatus] = useState<PaymentStatusType>("CREATED");
  const hasUpdatedStatus = useRef(false);

  const base64Encode = (str: string) => {
    return btoa(unescape(encodeURIComponent(str)));
  };

  // Update application status from DRAFT -> SUBMITTED
  const updateApplicationStatus = async () => {
    if (hasUpdatedStatus.current) return;
    hasUpdatedStatus.current = true;

    try {
      const userId = user?.userId || "";
      if (!userId) return;

      // Fetch user's applications
      const appRes = await apiFetch(
        `${apiConfig.getResourceUrl('applications')}?queryId=GET_APPLICATIONS_BY_USER_ID&args=user_id:${userId}`
      );

      if (!appRes.ok) return;
      const appData = await appRes.json();
      const applications = appData.resource || [];

      // Find DRAFT applications and update to SUBMITTED
      for (const app of applications) {
        if (app.status === "DRAFT") {
          const updatedApp = {
            ...app,
            status: "SUBMITTED",
          };
          const formData = new FormData();
          const jsonString = JSON.stringify(updatedApp);
          const base64Encoded = base64Encode(jsonString);
          formData.append('resource', base64Encoded);
          formData.append('queryId', 'CREATE');

          await apiFetch(
            `${apiConfig.getResourceUrl('applications')}`,
            {
              method: "POST",
              body: formData,
            }
          );
          console.log("Updated application", app.application_number, "to SUBMITTED");
        }
      }
    } catch (err) {
      console.error("Error updating application status:", err);
    }
  };

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const orderId = params.get("orderId");
    const round = params.get("round");

    if (!orderId) {
      setStatus("INVALID");
      return;
    }

    const interval = setInterval(async () => {
      const apiUrl = `${apiConfig.API_BASE_URL}/payments/status/${orderId}?round=${round === "true" ? true : false}`

      try {

        const res = await apiFetch(apiUrl);

        if (!res.ok) {
          setStatus("INVALID");
          clearInterval(interval);
          return;
        }

        const data = await res.json();

        setStatus(data.status);

        if (data.status === "SUCCESS") {
          clearInterval(interval);
          await updateApplicationStatus();
        } else if (data.status === "FAILED") {
          clearInterval(interval);
        }

      } catch (err) {
        console.error("Payment status check failed:", err);
      }

    }, 3000);

    return () => clearInterval(interval);

  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f4f7f6",
        padding: "20px",
      }}
    >

      <div
        className="bg-white p-5 rounded shadow-lg text-center"
        style={{ width: "450px", maxWidth: "100%" }}
      >

        {/* STATUS DISPLAY */}

        <div className="mb-4">

          {status === "CREATED" && (
            <>
              <Loader2
                size={60}
                className="text-primary mb-3 mx-auto"
                style={{ animation: "spin 2s linear infinite" }}
              />
              <h3 className="text-dark fw-bold">Processing Payment</h3>
              <p className="text-muted mt-2">
                Please wait while we confirm your payment.
                Do not refresh or close this page.
              </p>
            </>
          )}

          {status === "SUCCESS" && (
            <>
              <CheckCircle size={64} className="text-success mb-3 mx-auto" />
              <h3 className="text-success fw-bold">Payment Successful!</h3>
              <p className="text-muted mt-2">
                Your application fee has been received successfully.
              </p>
            </>
          )}

          {status === "FAILED" && (
            <>
              <XCircle size={64} className="text-danger mb-3 mx-auto" />
              <h3 className="text-danger fw-bold">Payment Failed</h3>
              <p className="text-muted mt-2">
                Unfortunately your payment could not be processed.
                Please try again.
              </p>
            </>
          )}

          {status === "INVALID" && (
            <>
              <AlertCircle size={64} className="text-warning mb-3 mx-auto" />
              <h3 className="text-dark fw-bold">Invalid Order</h3>
              <p className="text-muted mt-2">
                We could not find this payment order.
              </p>
            </>
          )}

        </div>

        {/* ACTION BUTTONS */}

        <div className="mt-4 pt-4 border-top">

          {status === "SUCCESS" && (
            <button
              className="btn btn-success px-4 py-2 w-100"
              style={{ fontSize: "16px", fontWeight: "500" }}
              onClick={() => navigate("/applicant/home")}
            >
              Go to Home
            </button>
          )}

          {(status === "FAILED" || status === "INVALID") && (
            <button
              className="btn btn-primary px-4 py-2 w-100"
              style={{ fontSize: "16px", fontWeight: "500" }}
              onClick={() => navigate("/paymentinitiate")}
            >
              <ArrowLeft size={18} className="me-2" />
              Try Again
            </button>
          )}

        </div>

        {/* Spinner animation */}

        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>

      </div>
    </div>
  );
};

export default PaymentStatus;